var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterDecline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 212,
    viewBox: "0 0 186 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_719_14941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.43 59.211C167.391 58.9674 167.352 58.7317 167.304 58.4882C167.281 58.3624 167.257 58.2289 167.226 58.1032C166.094 52.7996 162.834 48.1639 158.143 45.3432L86.1564 1.9564C80.8293 -1.25715 73.9936 -0.447868 69.5701 3.92067L9.72265 62.951C5.82553 66.7931 3.73555 72.0652 3.87698 77.4866C3.87698 77.6202 3.87698 77.7459 3.89269 77.8795C3.90055 78.123 3.92412 78.3666 3.93983 78.6102C3.94769 78.7359 3.94769 78.8695 3.9634 78.9952L3.99483 79.2859L5.09482 88.5651L85.3393 136.925C90.6664 140.139 97.5021 139.33 101.926 134.961L168.632 69.1738L167.501 59.6117C167.485 59.4782 167.454 59.3603 167.438 59.2267L167.43 59.211Z",
    fill: "url(#paint0_linear_719_14941)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.43 59.211C167.391 58.9674 167.352 58.7317 167.304 58.4882C167.281 58.3624 167.257 58.2289 167.226 58.1032C166.094 52.7996 162.834 48.1639 158.143 45.3432L86.1564 1.9564C80.8293 -1.25715 73.9936 -0.447868 69.5701 3.92067L9.72265 62.951C5.82553 66.7931 3.73555 72.0652 3.87698 77.4866C3.87698 77.6202 3.87698 77.7459 3.89269 77.8795C3.90055 78.123 3.92412 78.3666 3.93983 78.6102C3.94769 78.7359 3.94769 78.8695 3.9634 78.9952L3.99483 79.2859L5.09482 88.5651L85.3393 136.925C90.6664 140.139 97.5021 139.33 101.926 134.961L168.632 69.1738L167.501 59.6117C167.485 59.4782 167.454 59.3603 167.438 59.2267L167.43 59.211Z",
    fill: "url(#paint1_linear_719_14941)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.382 6.9527L4.61926 24.4678L19.615 150.977L167.378 133.462L152.382 6.9527Z",
    fill: "url(#paint2_radial_719_14941)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88485 77.8714C3.88485 77.7378 3.877 77.6121 3.86914 77.4785C3.86914 77.9657 3.90057 78.4528 3.95557 78.9399C3.94771 78.8221 3.93985 78.7121 3.932 78.5942C3.90843 78.3507 3.89271 78.1071 3.88485 77.8635V77.8714Z",
    fill: "url(#paint3_linear_719_14941)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.391 58.983C167.344 58.6845 167.297 58.3937 167.226 58.103C167.257 58.2287 167.281 58.3545 167.304 58.488C167.336 58.653 167.359 58.818 167.391 58.983Z",
    fill: "url(#paint4_linear_719_14941)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.926 134.945C97.4942 139.314 90.6664 140.123 85.3393 136.909L5.09485 88.5569L15.0734 172.675C15.9455 180.029 22.6083 185.278 29.9625 184.406L166.872 168.165C174.227 167.293 179.475 160.622 178.603 153.276L168.624 69.1577L101.918 134.945H101.926Z",
    fill: "url(#paint5_linear_719_14941)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4257 88.5257C91.0986 85.3122 84.2629 86.1215 79.8394 90.49L13.1327 156.277L15.0734 172.667C15.9455 180.022 22.6083 185.27 29.9626 184.398L166.872 168.157C174.227 167.285 179.475 160.622 178.603 153.268L176.662 136.878L96.4178 88.5179L96.4257 88.5257Z",
    fill: "url(#paint6_linear_719_14941)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 212.008C144.269 212.008 185.831 208.761 185.831 204.756C185.831 200.751 144.269 197.504 93 197.504C41.7305 197.504 0.168457 200.751 0.168457 204.756C0.168457 208.761 41.7305 212.008 93 212.008Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.45 43.2067L93.3542 35.2505L63.5963 73.0118L73.6923 80.968L103.45 43.2067Z",
    fill: "#EA4435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4369 78.0213L106.393 67.9253L68.6318 38.1674L60.6756 48.2634L98.4369 78.0213Z",
    fill: "#EA4435"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719_14941",
    x1: 194.724,
    y1: 126.967,
    x2: 74.5197,
    y2: 63.5264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C315"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_719_14941",
    x1: 194.724,
    y1: 126.967,
    x2: 74.5197,
    y2: 63.5264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C315"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_719_14941",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.7392 10.891) scale(131.858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#BCBEC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_719_14941",
    x1: 4.10312,
    y1: 77.8861,
    x2: 3.71994,
    y2: 78.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C315"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_719_14941",
    x1: 167.415,
    y1: 58.3778,
    x2: 167.204,
    y2: 58.7351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C315"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_719_14941",
    x1: 119.462,
    y1: 77.1561,
    x2: 65.386,
    y2: 168.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C315"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_719_14941",
    x1: 115.991,
    y1: 202.065,
    x2: 90.6061,
    y2: 143.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C315"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_14941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185.663,
    height: 212,
    fill: "white",
    transform: "translate(0.168457)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterDecline);
export default __webpack_public_path__ + "static/media/letter-decline.a55d6195fe44be2853b54c711ba0302b.svg";
export { ForwardRef as ReactComponent };